(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// 新規ページ用
(function ($) {
  var nav = $('#js-menu-trigger'),
      icon = $('#menu-icon'),
      mobileNav = $('#nav-header'),
      navItems = {
    1: nav,
    2: icon,
    3: mobileNav
  };
  nav.click(function (e) {
    e.preventDefault();

    if (!nav.hasClass('js-active')) {
      $.each(navItems, function (index, element) {
        element.addClass('js-active');
      });
    } else {
      $.each(navItems, function (index, element) {
        element.removeClass('js-active');
      });
    }
  }); //Sticky header scroll

  $(window).on('load', function () {
    $('#js-kv-arrow').click(function () {
      var speed = 500,
          href = $(this).attr("href"),
          target = $(href == "#" || href == "" ? 'html' : href),
          position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  }); // メニュー開いた後の左側写真変更

  var header_menu_item = $('.nav-header .menu-item'),
      haeder_menu_background = $('.nav-header > .menu-background');
  header_menu_item.hover(function () {
    var bg_image = $(this).data('background');
    haeder_menu_background.css({
      'background-image': 'url("' + bg_image + '")'
    }).addClass('js-active');
  }, function () {
    var bg_image = haeder_menu_background.data('background');
    haeder_menu_background.css({
      'background-image': 'url("' + bg_image + '")'
    }).removeClass('js-active');
  }); // Change the color of the sitename and menu icon

  var header = $('.header'),
      siteInfoHeader = $('.header').find('.site-info-header'),
      menuContainer = $('.header').children('.menu-container'),
      modalContainer = $('.kv-modal-menu-container'),
      kvAreaHeight = $('.kv-area').height(),
      contentTop = $('#js-menu-appear').offset().top,
      uri = window.location.pathname.replace('/', '');

  var changeColor = function changeColor() {
    var headerTop = header.offset().top;

    if (contentTop < headerTop) {
      menuContainer.addClass('js-active');
      modalContainer.addClass('js-active');
      siteInfoHeader.addClass('js-active'); // if(uri=='about.html') {
      //   siteInfo.addClass('js-active');
      // }
    } else {
      menuContainer.removeClass('js-active');
      modalContainer.removeClass('js-active');
      siteInfoHeader.removeClass('js-active'); // if(uri=='about.html') {
      //   siteInfo.removeClass('js-active');
      // }
    }
  }; //changeColor function


  $(window).on('scroll', changeColor); // viewport

  var viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    var value = window.outerWidth > 375 ? 'width=device-width,initial-scale=1' : 'width=375';

    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }

  addEventListener('resize', switchViewport, false);
  switchViewport(); //任意のタブにURLからリンクするための設定

  function getHashId(hashIDName) {
    if (hashIDName) {
      $('.transportation-tab li').find('a').each(function () {
        var idName = $(this).attr('href');

        if (idName == hashIDName) {
          var parentElm = $(this).parent();
          $('.transportation-tab li').removeClass("active");
          $(parentElm).addClass("active"); //表示させるエリア設定

          $(".transportation-content").removeClass("is-active");
          $(hashIDName).addClass("is-active");
        }
      });
    }
  } //タブをクリックしたら


  $('.transportation-tab a').on('click', function () {
    var idName = $(this).attr('href');
    getHashId(idName);
    return false;
  }); // 上記の動きをページが読み込まれたらすぐに動かす

  $(window).on('load', function () {
    $('.transportation-tab li:first-of-type').addClass("active");
    $('.transportation-content:first-of-type').addClass("is-active");
    var hashName = location.hash;
    getHashId(hashName);
  }); // トップへ戻るボタン

  $('#js-back-to-top').click(function (event) {
    event.preventDefault;
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  }); // グランピングページ予約欄

  $('.reservation-close').click(function (event) {
    event.preventDefault;
    $('.reservation-container').fadeOut();
  }); // FAQアコーディオン

  $('.faq-item-top').on('click', function (e) {
    var faqTop = $(this);
    var faq_content = $(this).siblings('.faq-item-bottom');
    faq_content.fadeToggle('300', 'linear', function () {
      var display = faq_content.css('display');

      if (display == 'block') {
        faqTop.addClass('js-active');
      } else if (display == 'none') {
        faqTop.removeClass('js-active');
      }
    });
  }); // Slickスライダー

  $('.activities-items').slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 800,
    centerMode: true,
    variableWidth: true,
    cssEase: 'ease',
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        centerMode: false
      }
    }]
  }); //客室・プランで左側のテント画像を右よりにさせる

  var windowWidth = window.outerWidth;

  if (windowWidth > 768) {
    $('.room-detail').each(function (index, element) {
      $(element).children('.room-detail-images').on('init', function (event, slick) {
        var prev_container = $(element).children('#room-detail-images').find('.slick-current').prev('.slick-active');
        prev_container.children('.room-detail-image').addClass('js-active-prev');
      });
    });
    $('.room-detail-images').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.room-detail-image').removeClass('js-active-prev');
      $('.room-detail-image').removeClass('js-active-next');
      $(slick.$slides.get(nextSlide)).prev('.room-detail-image-container').children('.room-detail-image').addClass('js-active-prev');
      $(slick.$slides.get(nextSlide)).next('.room-detail-image-container').children('.room-detail-image').addClass('js-active-next');
    });
  }

  $('.slide-items, .room-detail-images').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 1200,
    centerMode: true,
    variableWidth: true,
    centerPadding: '200px',
    cssEase: 'ease',
    arrows: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerPadding: '0',
        centerMode: false
      }
    }]
  });
  $('.feature-item-images').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    cssEase: 'ease',
    responsive: [{
      breakpoint: 768,
      settings: {
        centerMode: false
      }
    }]
  });
  $('.kv-area-bg-images').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    cssEase: 'ease',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 768,
      settings: {
        centerMode: false
      }
    }]
  });
  $('.feature-item-image-slide').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    cssEase: 'ease',
    responsive: [{
      breakpoint: 768,
      settings: {
        centerMode: false
      }
    }]
  });
  $('.meal-item-image-container').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1200,
    cssEase: 'ease',
    responsive: [{
      breakpoint: 768,
      settings: {
        centerMode: false
      }
    }]
  });
  window.addEventListener('DOMContentLoaded', function () {
    new ScrollHint('.js-scrollable');
  });
  var mySwiper = new Swiper('.swiper', {
    // 以下にオプションを設定
    loop: true,
    //最後に達したら先頭に戻る
    //ページネーション表示の設定
    pagination: {
      el: '.swiper-pagination',
      //ページネーションの要素
      type: 'bullets',
      //ページネーションの種類
      clickable: true //クリックに反応させる

    },
    //ナビゲーションボタン（矢印）表示の設定
    navigation: {
      nextEl: '.swiper-button-next',
      //「次へボタン」要素の指定
      prevEl: '.swiper-button-prev' //「前へボタン」要素の指定

    } //スクロールバー表示の設定
    // scrollbar: {
    //   el: '.swiper-scrollbar', //要素の指定
    // },

  });
  var mySwiper_kv = new Swiper('.swiper-kv', {
    loop: true,
    //最後に達したら先頭に戻る
    effect: "fade",
    //フェードのエフェクト
    autoplay: {
      delay: 4000,
      //5秒後に次の画像へ
      disableOnInteraction: false //ユーザー操作後に自動再生を再開する

    },
    speed: 2000,
    //２秒かけながら次の画像へ移動
    allowTouchMove: false //マウスでのスワイプを禁止

  }); //今日の日付を取得してフォームに入れる

  var today = new Date();
  today.setDate(today.getDate());
  var yyyy = today.getFullYear();
  var mm = ("0" + (today.getMonth() + 1)).slice(-2);
  var dd = ("0" + today.getDate()).slice(-2);
  document.getElementById("today").value = yyyy + '-' + mm + '-' + dd;

  var modalWrapOpen = function modalWrapOpen(e) {
    var dataModalOpen = e.currentTarget.dataset.modalOpen;
    Array.from(document.querySelectorAll('.works_modal_wrapper')).forEach(function (e, i) {
      if (e.getAttribute('data-modal') === dataModalOpen) {
        e.classList.toggle('is_open');
      }
    });
  };

  Array.from(document.querySelectorAll('.works_modal_open')).forEach(function (modalOpenElement) {
    modalOpenElement.addEventListener('click', modalWrapOpen);
  });

  var modalCloseAction = function modalCloseAction(e) {
    var targetModal = e.currentTarget.closest('.works_modal_wrapper');
    targetModal.classList.toggle('is_open');
  };

  Array.from(document.querySelectorAll('.works_modal_close')).forEach(function (modalCloseElement) {
    modalCloseElement.addEventListener('click', modalCloseAction);
  });
})(jQuery); // Fully reference jQuery after this point.

},{}]},{},[1]);
